import { Row, Col } from "react-bootstrap";
import "./App.css";
import styles from "./App.module.css";
import { useTheme } from "./ThemeContext";
import { useLang } from "./LangContext";

export default function FooterModule({ isXs, isSm, isMd, isLg, setCurPage }) {
  const { lang, changeLang, t } = useLang();
  const { s, toggleTheme } = useTheme();

  return (
    <>
      <style>{``}</style>
      <div className={`${styles.footerWrapper} mt-3`} style={s.cardBg}>
        <div className="d-flex align-items-center">
          <div>
            {/* <img src="/img/logoDark.png" alt="IMG" />
            <img src="/img/qwins.png" alt="IMG" className="ms-2" /> */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="142"
              height="40"
              viewBox="0 0 142 40"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M82.2641 19.5997C82.2641 21.8237 81.5281 23.7597 80.0561 25.4077L81.8321 27.2317L79.8881 28.9837L78.0401 27.0877C76.6161 27.9037 75.1201 28.3117 73.5521 28.3117C71.1521 28.3117 69.0961 27.4717 67.3841 25.7917C65.6881 24.0957 64.8401 22.0317 64.8401 19.5997C64.8401 17.1677 65.6881 15.1117 67.3841 13.4317C69.0801 11.7357 71.1361 10.8877 73.5521 10.8877C75.9681 10.8877 78.0241 11.7357 79.7201 13.4317C81.4161 15.1117 82.2641 17.1677 82.2641 19.5997ZM73.5521 25.6237C74.4161 25.6237 75.2561 25.4397 76.0721 25.0717L73.0001 21.9277L74.9441 20.1757L78.1601 23.4637C79.0561 22.3437 79.5041 21.0557 79.5041 19.5997C79.5041 17.8877 78.9281 16.4557 77.7761 15.3037C76.6241 14.1517 75.2161 13.5757 73.5521 13.5757C71.8881 13.5757 70.4801 14.1517 69.3281 15.3037C68.1761 16.4557 67.6001 17.8877 67.6001 19.5997C67.6001 21.3117 68.1761 22.7437 69.3281 23.8957C70.4801 25.0477 71.8881 25.6237 73.5521 25.6237Z"
                fill={s.logoColor}
              />
              <path
                d="M94.4923 15.7357L90.9163 27.9997H87.7243L82.9723 11.1997H85.8763L89.4043 24.3277L93.2203 11.1997H95.7643L99.5563 24.3277L103.084 11.1997H105.988L101.236 27.9997H98.0443L94.4923 15.7357Z"
                fill={s.logoColor}
              />
              <path
                d="M116.426 11.1997L124.346 22.5997V11.1997H127.106V27.9997H124.946L117.026 16.5997V27.9997H114.266V11.1997H116.426Z"
                fill={s.logoColor}
              />
              <path
                d="M131.691 27.2317C132.827 27.9517 134.203 28.3117 135.819 28.3117C137.611 28.3117 139.043 27.8717 140.115 26.9917C141.219 26.0957 141.771 24.8877 141.771 23.3677C141.867 22.0397 141.291 20.8877 140.043 19.9117C139.739 19.6717 139.331 19.4477 138.819 19.2397C138.195 18.9837 137.779 18.8237 137.571 18.7597C137.443 18.7117 136.979 18.5517 136.179 18.2797C134.883 17.8797 133.995 17.5037 133.515 17.1517C133.035 16.7837 132.795 16.2877 132.795 15.6637C132.795 15.0237 133.035 14.5197 133.515 14.1517C133.995 13.7677 134.635 13.5757 135.435 13.5757C137.083 13.5757 138.259 14.3597 138.963 15.9277L141.291 14.5837C140.747 13.4157 139.963 12.5117 138.939 11.8717C137.931 11.2157 136.763 10.8877 135.435 10.8877C133.931 10.8877 132.659 11.3277 131.619 12.2077C130.563 13.0717 130.035 14.2477 130.035 15.7357C130.035 17.2237 130.579 18.3517 131.667 19.1197C132.563 19.7117 133.739 20.2237 135.195 20.6557C136.619 21.0877 137.611 21.4877 138.171 21.8557C138.731 22.2237 139.011 22.7437 139.011 23.4157C139.011 24.0877 138.747 24.6237 138.219 25.0237C137.691 25.4237 136.915 25.6237 135.891 25.6237C133.779 25.6237 132.387 24.6797 131.715 22.7917L129.339 24.1837C129.787 25.4797 130.571 26.4957 131.691 27.2317Z"
                fill={s.logoColor}
              />
              <path
                d="M110.909 11.1997H108.149V27.9997H110.909V11.1997Z"
                fill={s.logoColor}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.6718 19.7921C29.2031 19.7073 31.3711 19.1313 33.1758 18.0638C35.1492 16.8965 36.1297 15.5029 36.1172 13.8828C36.1178 12.2551 35.1382 10.8616 33.1784 9.70246C31.2187 8.5433 28.8629 7.96387 26.1109 7.96418C23.372 7.95681 21.0158 8.53676 19.0423 9.70404C17.0689 10.8713 16.0819 12.2688 16.0814 13.8966C16.1068 15.5243 17.0929 16.9139 19.0396 18.0654C20.3115 18.8177 21.8561 19.3396 23.6733 19.6312L23.6338 21.4278L26.6323 21.5196L26.6718 19.7921ZM23.7128 17.7194C22.7523 17.5045 21.9217 17.1898 21.2208 16.7752C19.8711 15.9769 19.1964 15.0249 19.1967 13.9192C19.1971 12.8136 19.8919 11.8499 21.2811 11.0282C22.6703 10.2065 24.2995 9.79559 26.1688 9.79538C28.038 9.79517 29.6475 10.1942 30.9972 10.9926C32.347 11.791 33.0217 12.743 33.0213 13.8486C33.021 14.9542 32.3262 15.9179 30.937 16.7396C29.7555 17.4384 28.347 17.8417 26.7113 17.9494L26.7708 14.8282L23.7722 14.7364L23.7128 17.7194Z"
                fill={s.logoColor}
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.7377 0.900688C27.7091 -0.299974 24.4188 -0.300266 22.3896 0.900033L1.52162 13.2433C0.505033 13.8446 -0.00217417 14.6331 7.00477e-06 15.4212L0.00433117 23.8753C-0.00350785 24.6677 0.503672 25.4616 1.52587 26.0662L22.3907 38.4077C24.4195 39.6077 27.7089 39.6077 29.7377 38.4077L50.6025 26.0662C51.642 25.4699 52.1492 24.6833 52.1428 23.8958L52.1212 15.4212C52.1215 14.6349 51.6144 13.8485 50.6005 13.2484L29.7377 0.900688ZM29.5996 1.76403C27.5721 0.564086 24.2838 0.563793 22.2557 1.76338L4.11363 12.4942C2.08599 13.6935 2.08599 15.638 4.11363 16.8374L22.2568 27.5689C24.2845 28.7682 27.5719 28.7682 29.5996 27.5689L47.7362 16.8413C49.7634 15.6422 49.7639 13.6982 47.7373 12.4988L29.5996 1.76403Z"
                fill={s.logoColor}
              />
            </svg>
          </div>
          <div className="ms-auto">
            {/* <img src="/img/vkSquare.png" alt="IMG" /> */}
            {isXs ? (
              <>
                <div className="icons-row">
                  <a href="https://vk.com/qwinsco">
                    <div className="icon-static-square vk-static">
                      {/* VK SVG теперь 32×32 */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        viewBox="0 0 41 40"
                        fill="none"
                      >
                        <path
                          d="M10.7812 14.0096C10.9331 21.5036 14.6344 26 21.1259 26H21.1354H21.5055V21.715C23.8876 21.9552 25.6908 23.723 26.4121 26H29.7813C29.4356 24.7062 28.823 23.501 27.9839 22.4644C27.1446 21.4277 26.098 20.5829 24.9126 19.9856C25.9748 19.3308 26.892 18.4613 27.6073 17.4314C28.3226 16.4015 28.8203 15.2334 29.0695 14H26.0135C25.3492 16.3827 23.3752 18.5444 21.5055 18.7462V14.0096H18.4401V22.3107C16.542 21.8303 14.1504 19.5052 14.046 14.0096H10.7812Z"
                          fill="#F8F8F8"
                        />
                      </svg>
                    </div>
                  </a>

                  <a href="https://t.me/qwinsco">
                    <div className="icon-static-square tg-static">
                      {/* Telegram SVG остаётся 24×24 */}
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.92878 11.8099C8.17615 9.52374 11.6753 8.01654 13.426 7.28833C18.4247 5.20916 19.4634 4.84799 20.1404 4.83606C20.2893 4.83344 20.6223 4.87034 20.8379 5.04534C21.02 5.1931 21.0702 5.39271 21.0942 5.5328C21.1182 5.6729 21.148 5.99204 21.1243 6.2414C20.8534 9.08763 19.6812 15.9947 19.0849 19.1825C18.8326 20.5314 18.3359 20.9836 17.8549 21.0279C16.8096 21.1241 16.0158 20.3371 15.0034 19.6735C13.4192 18.635 12.5242 17.9885 10.9864 16.9751C9.2092 15.804 10.3613 15.1603 11.3741 14.1084C11.6392 13.8331 16.2447 9.64397 16.3338 9.26395C16.3449 9.21642 16.3553 9.03926 16.25 8.94571C16.1448 8.85216 15.9895 8.88415 15.8774 8.9096C15.7185 8.94566 13.1876 10.6184 8.2849 13.928C7.56653 14.4212 6.91586 14.6616 6.33288 14.649C5.69018 14.6351 4.4539 14.2856 3.53485 13.9869C2.4076 13.6204 1.51168 13.4267 1.5897 12.8044C1.63033 12.4803 2.07669 12.1488 2.92878 11.8099Z"
                          fill="#F8F8F8"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </>
            ) : (
              <>
                <div className="icon-wrapper me-2">
                  <a href="https://vk.com/qwinsco">
                    <div
                      className="icon-container"
                      style={{ backgroundColor: "#07F" }}
                    >
                      <span className="icon-label">ВКОНТАКТЕ</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="41"
                        height="40"
                        viewBox="0 0 41 40"
                        fill="none"
                      >
                        <rect
                          x="0.78125"
                          width="40"
                          height="40"
                          rx="8"
                          fill="#0077FF"
                        />
                        <path
                          d="M10.7812 14.0096C10.9331 21.5036 14.6344 26 21.1259 26H21.1354H21.5055V21.715C23.8876 21.9552 25.6908 23.723 26.4121 26H29.7813C29.4356 24.7062 28.823 23.501 27.9839 22.4644C27.1446 21.4277 26.098 20.5829 24.9126 19.9856C25.9748 19.3308 26.892 18.4613 27.6073 17.4314C28.3226 16.4015 28.8203 15.2334 29.0695 14H26.0135C25.3492 16.3827 23.3752 18.5444 21.5055 18.7462V14.0096H18.4401V22.3107C16.542 21.8303 14.1504 19.5052 14.046 14.0096H10.7812Z"
                          fill="#F8F8F8"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
                <div className="icon-wrapper">
                  <a href="https://t.me/qwinsco">
                    <div className="icon-container">
                      <span className="icon-label">TELEGRAM</span>
                      <svg
                        className="icon-svg"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.92878 11.8099C8.17615 9.52374 11.6753 8.01654 13.426 7.28833C18.4247 5.20916 19.4634 4.84799 20.1404 4.83606C20.2893 4.83344 20.6223 4.87034 20.8379 5.04534C21.02 5.1931 21.0702 5.39271 21.0942 5.5328C21.1182 5.6729 21.148 5.99204 21.1243 6.2414C20.8534 9.08763 19.6812 15.9947 19.0849 19.1825C18.8326 20.5314 18.3359 20.9836 17.8549 21.0279C16.8096 21.1241 16.0158 20.3371 15.0034 19.6735C13.4192 18.635 12.5242 17.9885 10.9864 16.9751C9.2092 15.804 10.3613 15.1603 11.3741 14.1084C11.6392 13.8331 16.2447 9.64397 16.3338 9.26395C16.3449 9.21642 16.3553 9.03926 16.25 8.94571C16.1448 8.85216 15.9895 8.88415 15.8774 8.9096C15.7185 8.94566 13.1876 10.6184 8.2849 13.928C7.56653 14.4212 6.91586 14.6616 6.33288 14.649C5.69018 14.6351 4.4539 14.2856 3.53485 13.9869C2.4076 13.6204 1.51168 13.4267 1.5897 12.8044C1.63033 12.4803 2.07669 12.1488 2.92878 11.8099Z"
                          fill="#F8F8F8"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
        <div
          className={styles.footerStick}
          style={{ backgroundColor: s.footerStick }}
        ></div>
        <Row xs={2} md={3} lg={4} xl={5} className="gy-4">
          <Col>
            <Row xs={1} className="gy-2">
              <Col
                className={styles.footerHeader}
                style={{ color: s.footerHeader }}
              >
                {t("footerServicesHeader")}
              </Col>
              <Col>
                <span
                  className={styles.footerLink}
                  style={s.footerLink}
                  onClick={() => {
                    setCurPage("virtualServers");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  {t("footerServicesBtn2")}
                </span>
              </Col>
              <Col>
                <span
                  className={styles.footerLink}
                  style={s.footerLink}
                  onClick={() => {
                    setCurPage("dedicatedServers");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  {t("footerServicesBtn1")}
                </span>
              </Col>
              <Col>
                {/* <span className={styles.footerLink} style={s.footerLink}>
                  {t("footerServicesBtn3")}
                </span> */}
                <span
                  className={styles.footerLink}
                  style={s.footerLink}
                  onClick={() => {
                    setCurPage("virtualHosting");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  {t("footerServicesBtn3")}
                </span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row xs={1} className="gy-2">
              <Col
                className={styles.footerHeader}
                style={{ color: s.footerHeader }}
              >
                {t("footerContactsHeader")}
              </Col>
              <Col>
                <span className={styles.footerLink} style={s.footerLink}>
                  help@qwins.co
                </span>
              </Col>
              <Col>
                <a
                  className={styles.footerLink}
                  style={{ ...s.footerLink, textDecoration: "none" }}
                  href="https://t.me/qwinshelp"
                >
                  {t("footerContactsBtn2")}
                </a>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row xs={1} className="gy-2">
              <Col
                className={styles.footerHeader}
                style={{ color: s.footerHeader }}
              >
                {t("footerSocialHeader")}
              </Col>
              <Col>
                <a
                  className={styles.footerLink}
                  style={{ ...s.footerLink, textDecoration: "none" }}
                  href="https://t.me/qwinsco"
                >
                  {t("footerSocialBtn1")}
                </a>
              </Col>
              <Col>
                <a
                  className={styles.footerLink}
                  style={{ ...s.footerLink, textDecoration: "none" }}
                  href="https://t.me/qwins_robot"
                >
                  bot telegram
                </a>
              </Col>
              <Col>
                <a
                  className={styles.footerLink}
                  style={{ ...s.footerLink, textDecoration: "none" }}
                  href="https://vk.com/qwinsco"
                >
                  {t("footerSocialBtn3")}
                </a>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row xs={1} className="gy-2">
              <Col
                className={styles.footerHeader}
                style={{ color: s.footerHeader }}
              >
                {t("footerInfoHeader")}
              </Col>
              <Col>
                <a
                  className={styles.footerLink}
                  style={{ ...s.footerLink, textDecoration: "none" }}
                  href="https://wiki.qwins.co/"
                >
                  {t("footerInfoBtn1")}
                </a>
              </Col>
              <Col>
                <span
                  className={styles.footerLink}
                  style={s.footerLink}
                  onClick={() => {
                    setCurPage("dataCenter");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  {t("footerInfoBtn2")}
                </span>
              </Col>
              <Col>
                <span
                  className={styles.footerLink}
                  style={s.footerLink}
                  onClick={() => {
                    setCurPage("referral");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  {t("footerInfoBtn3")}
                </span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row xs={1} className="gy-2">
              <Col
                className={styles.footerHeader}
                style={{ color: s.footerHeader }}
              >
                {t("footerOtherHeader")}
              </Col>
              <Col>
                <span
                  className={styles.footerLink}
                  style={s.footerLink}
                  onClick={() => {
                    setCurPage("resources");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  {t("footerOtherBtn1")}
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
        <div
          className={styles.footerStick}
          style={{ backgroundColor: s.footerStick }}
        ></div>

        {!(isXs || isSm || isMd) ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              color: "#A7AAAF",
              fontSize: "14px",
            }}
          >
            {/* Левая часть */}
            <span style={{ color: s.footerHeader }}>
              {t("footerBottomInfo1")}
            </span>

            {/* Правая группа */}
            <div style={{ display: "flex", gap: "20px" }}>
              <span
                className={styles.footerLink}
                style={{
                  "--footer-text": s.footerHeader,
                  "--footer-hover": "#23c1ff",
                }}
                onClick={() => {
                  setCurPage("privacy");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                {t("footerBottomInfo2")}
              </span>
              <span
                className={styles.footerLink}
                style={{
                  "--footer-text": s.footerHeader,
                  "--footer-hover": "#23c1ff",
                }}
                onClick={() => {
                  setCurPage("terms");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                {t("footerBottomInfo3")}
              </span>
            </div>
          </div>
        ) : (
          <Row style={{ color: "#A7AAAF", fontSize: "14px" }}>
            <Col xs={12} className={styles.footerLink}>
              {t("footerBottomInfo1")}
            </Col>
            <Col
              xs={12}
              style={{ textAlign: "left" }}
              className={styles.footerLink}
              onClick={() => {
                setCurPage("privacy");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              {t("footerBottomInfo2")}
            </Col>
            <Col
              xs={12}
              style={{ textAlign: "left" }}
              className={styles.footerLink}
              onClick={() => {
                setCurPage("terms");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              {t("footerBottomInfo3")}
            </Col>
          </Row>
        )}

        <div className="d-flex align-items-center mt-3">
          <div
            className="d-flex flex-wrap align-items-center"
            style={{ gap: `8px ${isXs ? 8 : 16}px` }}
          >
            {/* <img src="/img/visa.png" alt="IMG" /> */}
            <div className="visa-container">
              <svg
                className="visa-icon visa-icon--gray"
                viewBox="0 0 49 20"
                fill="none"
              >
                <path
                  d="M20.9669 16.833H17.4164L19.6415 3.19967H23.2L20.9749 16.833H20.9669ZM42.4305 16.833H45.6999L42.8482 3.19967H39.9805C38.6631 3.19967 38.3418 4.21634 38.3418 4.21634L33.0161 16.833H36.7272L37.4743 14.808H42.0048L42.4225 16.833H42.4305ZM38.5105 12.008L40.3822 6.90801L41.4264 12.008H38.5105ZM33.3053 6.47467L33.8113 3.54967C33.8113 3.54967 32.2449 2.95801 30.6143 2.95801C28.8471 2.95801 24.6459 3.72467 24.6459 7.46634C24.6459 10.9913 29.57 11.033 29.57 12.883C29.57 14.733 25.152 14.3997 23.6981 13.233L23.1679 16.2913C23.1679 16.2913 24.7584 17.0663 27.1843 17.0663C29.6182 17.0663 33.2892 15.8163 33.2892 12.3997C33.2892 8.85801 28.3089 8.52467 28.3089 6.98301C28.3089 5.44134 31.779 5.64134 33.3053 6.48301V6.47467ZM14.4202 3.19967L11.0223 12.5747L10.6207 10.558L10.6126 10.508C10.3877 9.92467 9.47199 7.83301 7.3192 6.09134C6.83723 5.70801 6.32313 5.34134 5.79297 5.02467L8.87756 16.833H12.5807L18.2518 3.19967H14.4202Z"
                  fill="#646474"
                />
                <path
                  d="M10.6676 10.6671L9.44664 4.40039C9.44664 4.40039 9.29402 3.15039 7.71959 3.15039H1.98418L1.91992 3.37539C1.91992 3.37539 4.67517 3.94206 7.31795 6.08372C8.81192 7.27077 9.9692 8.85428 10.6676 10.6671Z"
                  fill="#646474"
                />
              </svg>

              <svg
                className="visa-icon visa-icon--color"
                viewBox="0 0 49 20"
                fill="none"
              >
                <path
                  d="M20.9669 16.833H17.4164L19.6415 3.19967H23.2L20.9749 16.833H20.9669ZM42.4305 16.833H45.6999L42.8482 3.19967H39.9805C38.6631 3.19967 38.3418 4.21634 38.3418 4.21634L33.0161 16.833H36.7272L37.4743 14.808H42.0048L42.4225 16.833H42.4305ZM38.5105 12.008L40.3822 6.90801L41.4264 12.008H38.5105ZM33.3053 6.47467L33.8113 3.54967C33.8113 3.54967 32.2449 2.95801 30.6143 2.95801C28.8471 2.95801 24.6459 3.72467 24.6459 7.46634C24.6459 10.9913 29.57 11.033 29.57 12.883C29.57 14.733 25.152 14.3997 23.6981 13.233L23.1679 16.2913C23.1679 16.2913 24.7584 17.0663 27.1843 17.0663C29.6182 17.0663 33.2892 15.8163 33.2892 12.3997C33.2892 8.85801 28.3089 8.52467 28.3089 6.98301C28.3089 5.44134 31.779 5.64134 33.3053 6.48301V6.47467ZM14.4202 3.19967L11.0223 12.5747L10.6207 10.558L10.6126 10.508C10.3877 9.92467 9.47199 7.83301 7.3192 6.09134C6.83723 5.70801 6.32313 5.34134 5.79297 5.02467L8.87756 16.833H12.5807L18.2518 3.19967H14.4202Z"
                  fill="#00569D"
                />
                <path
                  d="M10.6676 10.6671L9.44664 4.40039C9.44664 4.40039 9.29402 3.15039 7.71959 3.15039H1.98418L1.91992 3.37539C1.91992 3.37539 4.67517 3.94206 7.31795 6.08372C8.81192 7.27077 9.9692 8.85428 10.6676 10.6671Z"
                  fill="#FAA519"
                />
              </svg>
            </div>
            {/* <img src="/img/mir.png" alt="IMG" className="ms-2 ms-md-3" /> */}
            <div className="mir-container">
              <svg
                className="mir-icon mir-icon--gray"
                viewBox="0 0 49 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_gray)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M43.5792 0H34.277C34.7748 2.88167 37.777 5.57556 41.0748 5.57556H48.4792C48.5804 5.29389 48.5803 4.92556 48.5803 4.64389C48.5803 2.04389 46.3792 0 43.5792 0ZM35.0781 6.03778V13H39.5737V9.28778H43.5792C44.6327 9.28019 45.6561 8.96101 46.5008 8.37658C47.3456 7.79215 47.9678 6.9729 48.277 6.03778H35.0781ZM19.0792 0V13H23.077C23.077 13 24.0803 13 24.5781 12.0756L28.0781 5.57556H28.5759V13H33.0792V0H29.0737C29.0737 0 28.0781 0.0938889 27.5803 0.938889L24.0803 7.43889H23.5748V0H19.0792ZM0.078125 13V0H4.57368C4.57368 0 5.88035 0 6.58035 1.85611C8.37701 6.78167 8.57924 7.43167 8.57924 7.43167C8.57924 7.43167 8.9759 6.22556 10.5781 1.85611C11.2781 0 12.577 0 12.577 0H17.0803V13H12.577V6.03778H12.0792L9.56701 13H7.5759L5.07924 6.03778H4.57368V13H0.078125Z"
                    fill="#646474"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_gray">
                    <rect width="49" height="13" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg
                className="mir-icon mir-icon--color"
                viewBox="0 0 49 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_color)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.0781 13V6.03778H48.277C47.9678 6.9729 47.3456 7.79215 46.5008 8.37658C45.6561 8.96101 44.6327 9.28019 43.5792 9.28778H39.5737V13H35.0781ZM19.0792 13V0H23.5748V7.43889H24.0803L27.5803 0.938889C28.0781 0.0938889 29.0737 0 29.0737 0H33.0792V13H28.5759V5.57556H28.0781L24.5781 12.0756C24.0803 13 23.077 13 23.077 13H19.0792ZM0.078125 0V13H4.57368V6.03778H5.07924L7.5759 13H9.56701L12.0792 6.03778H12.577V13H17.0803V0H12.577C12.577 0 11.2781 0 10.5781 1.85611C8.9759 6.22556 8.57924 7.43167 8.57924 7.43167C8.57924 7.43167 8.37701 6.78167 6.58035 1.85611C5.88035 0 4.57368 0 4.57368 0H0.078125Z"
                    fill="#01754E"
                  />
                  <path
                    d="M43.5792 0H34.277C34.7748 2.88167 37.777 5.57556 41.0748 5.57556H48.4792C48.5804 5.29389 48.5803 4.92556 48.5803 4.64389C48.5803 2.04389 46.3792 0 43.5792 0Z"
                    fill="#127EE9"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_color">
                    <rect width="49" height="13" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            {/* <img src="/img/mastercard.png" alt="IMG" className="ms-2 ms-md-3" /> */}
            <div className="mastercard-container">
              <div className="mastercard-default">
                <svg
                  className="mastercard-part part1"
                  width="41"
                  height="24"
                  viewBox="0 0 41 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.7235 12.6156C23.7235 11.9516 23.8361 11.3596 24.0451 10.8476L24.029 10.7276L24.0129 10.5676L23.9566 10.1756C23.7959 10.4476 23.5788 10.9916 23.4582 11.6156C22.7347 11.5356 22.6141 12.1276 22.1478 15.1516H20.8374L20.9017 14.8236C21.1268 13.2876 21.4163 11.7356 21.5851 10.2076H22.7829C22.791 10.4556 22.7347 10.7036 22.7025 10.9516C23.1045 10.3676 23.41 10.0636 23.9566 10.1756L23.9486 10.1116L23.9164 9.92759L23.8361 9.50359L23.828 9.45559H16.448C16.5445 9.02359 16.657 8.59959 16.7937 8.18359H23.4662C23.3382 7.80297 23.1906 7.42915 23.0241 7.06359L22.9678 6.91959H17.3082C17.5172 6.47959 17.7504 6.05559 17.9996 5.64759H22.2684L22.0513 5.31159L21.987 5.21559C21.7861 4.92759 21.577 4.64759 21.3519 4.37559H18.9241C19.2939 3.92759 19.7039 3.49559 20.13 3.10359C18.4002 1.54196 16.2519 0.51382 13.9461 0.144057C11.6402 -0.225705 9.27615 0.0788254 7.14094 1.02066C5.00574 1.96248 3.19133 3.50108 1.91812 5.44953C0.644911 7.39799 -0.0323004 9.67245 -0.0312488 11.9966C-0.0301972 14.3208 0.649073 16.5946 1.92404 18.542C3.19902 20.4893 5.01482 22.0262 7.15087 22.9662C9.28693 23.9061 11.6513 24.2085 13.9568 23.8367C16.2623 23.4648 18.4096 22.4348 20.138 20.8716L20.1702 20.8556L20.5239 20.5196L20.6445 20.3996L20.8857 20.1436L21.0143 20.0076L21.2796 19.7036L21.36 19.6236H18.9161C18.5945 19.2156 18.281 18.7916 17.9996 18.3436H22.2684L22.3247 18.2636L22.6462 17.7116L22.8874 17.2316L22.9276 17.1676L22.9678 17.0796H17.3082C17.1153 16.6636 16.9464 16.2396 16.8017 15.7996H23.4743L23.5306 15.6396L23.5788 15.4876L23.6994 15.0876L23.7315 14.9596C23.8223 14.6035 23.8947 14.243 23.9486 13.8796C23.7878 13.4796 23.7155 13.0476 23.7235 12.6156ZM5.08056 15.1516L5.83625 10.4796L4.16409 15.1516H3.27174L3.15919 10.5036L2.37135 15.1516H1.14939L2.17037 9.07159H4.05154L4.09978 12.8316L5.36998 9.07159H7.4039L6.39096 15.1516H5.08056ZM9.47801 15.1516L9.50213 14.6396C9.18056 15.0476 8.73037 15.2396 8.13547 15.2396C7.42801 15.2396 6.93762 14.6876 6.93762 13.8876C6.93762 12.6876 7.78174 11.9836 9.23684 11.9836C9.38154 11.9836 9.57448 11.9916 9.76743 12.0236C9.80762 11.8556 9.81566 11.7836 9.81566 11.7036C9.81566 11.3676 9.59056 11.2476 8.97958 11.2476C8.50527 11.2476 8.03899 11.3276 7.59684 11.4716L7.78174 10.3516C8.2855 10.1878 8.81142 10.1015 9.34135 10.0956C10.4668 10.0956 11.0617 10.5996 11.0617 11.5436C11.0617 11.7996 11.0215 12.1116 10.9572 12.5276C10.8447 13.2476 10.5955 14.7836 10.5633 15.1516H9.48605H9.47801ZM13.3047 12.2076C13.9639 12.5116 14.2292 12.9036 14.2292 13.5836C14.2292 14.7196 13.5941 15.2396 12.2194 15.2396C11.4155 15.2156 11.1502 15.1596 10.8527 15.0956L11.0296 13.9516C11.4476 14.0876 11.8174 14.1436 12.2033 14.1436C12.7259 14.1436 12.959 14.0076 12.959 13.7036C12.959 13.4716 12.8786 13.3996 12.348 13.1516C11.6566 12.8316 11.3512 12.3996 11.3512 11.7756C11.3512 10.8556 11.8496 10.0956 13.3127 10.0956C13.6102 10.0956 14.1247 10.1436 14.4623 10.1916L14.2774 11.3436C13.9659 11.2969 13.6518 11.2702 13.3368 11.2636C12.9188 11.2636 12.6937 11.4076 12.6937 11.6716C12.6937 11.9036 12.7661 11.9596 13.3127 12.2076H13.3047ZM16.7857 11.3916H16.1184C15.9657 12.3356 15.7486 13.5116 15.7486 13.6636C15.7486 13.9196 15.8853 14.0316 16.1988 14.0316C16.3435 14.0316 16.4641 14.0156 16.5525 13.9836L16.3757 15.0796C16.0139 15.1916 15.7325 15.2396 15.4351 15.2396C14.7678 15.2396 14.398 14.8556 14.398 14.1516C14.398 13.9356 14.5025 13.3516 14.5829 12.8316L15.1457 9.45559H16.448L16.2953 10.2076H16.9625L16.7857 11.3996V11.3916ZM19.2296 14.1196C19.6959 14.1196 20.1139 14.0236 20.5802 13.8076L20.3631 15.0396C19.921 15.1756 19.4868 15.2396 19.0286 15.2396C17.5815 15.2396 16.8178 14.4796 16.8178 13.0316C16.8178 11.3436 17.7825 10.0956 19.0929 10.0956C20.1621 10.0956 20.8455 10.7916 20.8455 11.8876C20.8455 12.2476 20.7972 12.6076 20.6847 13.1036H18.0961C18.0157 13.8236 18.4739 14.1196 19.2215 14.1196H19.2296Z"
                    fill="#646474"
                  />
                </svg>

                <svg
                  className="mastercard-part part2"
                  width="41"
                  height="24"
                  viewBox="0 0 41 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g opacity="0.55">
                    <path
                      opacity="0.55"
                      d="M36.5043 11.376C35.9174 11.376 35.4914 12.064 35.4914 13.04C35.4914 13.68 35.7165 14.016 36.1586 14.016C36.7696 14.016 37.2037 13.328 37.2037 12.344C37.2037 11.72 36.9625 11.376 36.5043 11.376ZM28.8108 13.68C28.8108 13.992 28.9957 14.192 29.277 14.192C29.8076 14.192 30.1935 13.68 30.2176 12.952C30.1218 12.9376 30.0251 12.9296 29.9282 12.928C29.1806 12.928 28.8027 13.184 28.8027 13.68H28.8108Z"
                      fill="#646474"
                    />
                    <path
                      opacity="0.55"
                      d="M28.2247 1.02121e-05C26.4453 -0.00230514 24.6876 0.389122 23.079 1.14596C21.4703 1.90279 20.0508 3.0061 18.9233 4.37601H21.3512C21.6888 4.77601 21.9943 5.20001 22.2757 5.64801H17.9988C17.7496 6.05601 17.5165 6.48001 17.3075 6.92001H22.9671C23.16 7.32801 23.3288 7.75201 23.4816 8.19201H16.801C16.6563 8.60801 16.5437 9.02401 16.4473 9.45601H23.8273L23.9559 10.176C23.988 10.4 24.0202 10.624 24.0363 10.848C24.5106 9.66401 25.4592 8.92801 26.6731 8.92801C27.2359 8.92801 27.9192 9.16801 28.1122 9.24001L27.8951 10.56C27.4288 10.32 27.0912 10.232 26.7214 10.232C25.7567 10.232 25.0653 11.168 25.0653 12.512C25.0653 13.432 25.5235 13.992 26.2873 13.992C26.6088 13.992 26.9626 13.896 27.3967 13.672L27.1635 15.064C26.6812 15.2 26.3757 15.248 26.0059 15.248C25.5621 15.2684 25.1234 15.1475 24.7534 14.903C24.3833 14.6584 24.1012 14.3029 23.9479 13.888C23.8433 14.552 23.6826 15.192 23.4816 15.808H16.801C16.9457 16.248 17.1145 16.672 17.3075 17.088H22.9671C22.7581 17.52 22.533 17.944 22.2757 18.352H18.0069C18.2802 18.8 18.5857 19.224 18.9233 19.632H21.3512C20.9805 20.0819 20.5775 20.5043 20.1453 20.896C21.5971 22.1994 23.3458 23.1316 25.2404 23.6123C27.1351 24.093 29.1188 24.1077 31.0205 23.6551C32.9221 23.2026 34.6845 22.2963 36.1557 21.0146C37.6268 19.7329 38.7624 18.1143 39.4645 16.2983C40.1667 14.4824 40.4142 12.5237 40.1858 10.5913C39.9574 8.65885 39.26 6.81077 38.1536 5.20648C37.0472 3.60219 35.5652 2.28989 33.8354 1.38283C32.1056 0.475759 30.18 0.00116899 28.2247 1.02121e-05ZM31.1671 15.152H30.0898L30.1139 14.64C29.7843 15.04 29.3422 15.24 28.7473 15.24C28.0237 15.24 27.5414 14.688 27.5414 13.888C27.5414 12.688 28.3935 11.984 29.8406 11.984C29.9853 11.984 30.1782 11.992 30.3712 12.016C30.4114 11.856 30.4275 11.784 30.4275 11.696C30.4275 11.376 30.1943 11.248 29.5833 11.248C29.1171 11.248 28.6508 11.328 28.2006 11.472L28.3855 10.352C28.8918 10.1874 29.4205 10.1011 29.9531 10.096C31.0786 10.096 31.6655 10.592 31.6655 11.544C31.6655 11.8 31.6253 12.112 31.561 12.528C31.4484 13.248 31.2073 14.784 31.1751 15.152H31.1671ZM32.9116 15.152H31.6092L31.6655 14.824C31.8906 13.288 32.18 11.736 32.3488 10.208H33.5547C33.5547 10.456 33.5065 10.704 33.4743 10.952C33.8763 10.368 34.1737 10.064 34.7204 10.176C34.4823 10.6276 34.3169 11.1135 34.23 11.616C33.4904 11.536 33.3779 12.128 32.9116 15.152ZM36.8508 15.152L36.9151 14.696C36.5533 15.072 36.1916 15.24 35.7092 15.24C34.7606 15.24 34.1335 14.424 34.1335 13.184C34.1335 11.544 35.1063 10.152 36.2559 10.152C36.7704 10.152 37.1482 10.36 37.51 10.824L37.7994 9.06401H39.0857L38.0969 15.152H36.8508Z"
                      fill="#646474"
                    />
                  </g>
                </svg>

                <svg
                  className="mastercard-part part3"
                  width="41"
                  height="24"
                  viewBox="0 0 41 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.0278 11.2236C18.6098 11.2236 18.3204 11.5436 18.1998 12.1036H19.6308C19.6388 11.9996 19.7674 11.2236 19.0278 11.2236ZM8.20703 13.6796C8.20703 13.9916 8.38389 14.1916 8.67331 14.1916C9.20389 14.1916 9.58978 13.6796 9.61389 12.9516C9.51541 12.9369 9.41603 12.9288 9.31644 12.9276C8.57684 12.9276 8.20703 13.1836 8.20703 13.6796Z"
                    fill="#646474"
                  />
                </svg>
              </div>

              <div className="mastercard-hover">
                <svg
                  className="mastercard-part part1"
                  width="41"
                  height="24"
                  viewBox="0 0 41 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.7235 12.6156C23.7235 11.9516 23.8361 11.3596 24.0451 10.8476L24.029 10.7276L24.0129 10.5676L23.9566 10.1756C23.7959 10.4476 23.5788 10.9916 23.4582 11.6156C22.7347 11.5356 22.6141 12.1276 22.1478 15.1516H20.8374L20.9017 14.8236C21.1268 13.2876 21.4163 11.7356 21.5851 10.2076H22.7829C22.791 10.4556 22.7347 10.7036 22.7025 10.9516C23.1045 10.3676 23.41 10.0636 23.9566 10.1756L23.9486 10.1116L23.9164 9.92759L23.8361 9.50359L23.828 9.45559H16.448C16.5445 9.02359 16.657 8.59959 16.7937 8.18359H23.4662C23.3382 7.80297 23.1906 7.42915 23.0241 7.06359L22.9678 6.91959H17.3082C17.5172 6.47959 17.7504 6.05559 17.9996 5.64759H22.2684L22.0513 5.31159L21.987 5.21559C21.7861 4.92759 21.577 4.64759 21.3519 4.37559H18.9241C19.2939 3.92759 19.7039 3.49559 20.13 3.10359C18.4002 1.54196 16.2519 0.51382 13.9461 0.144057C11.6402 -0.225705 9.27615 0.0788254 7.14094 1.02066C5.00574 1.96248 3.19133 3.50108 1.91812 5.44953C0.644911 7.39799 -0.0323004 9.67245 -0.0312488 11.9966C-0.0301972 14.3208 0.649073 16.5946 1.92404 18.542C3.19902 20.4893 5.01482 22.0262 7.15087 22.9662C9.28693 23.9061 11.6513 24.2085 13.9568 23.8367C16.2623 23.4648 18.4096 22.4348 20.138 20.8716L20.1702 20.8556L20.5239 20.5196L20.6445 20.3996L20.8857 20.1436L21.0143 20.0076L21.2796 19.7036L21.36 19.6236H18.9161C18.5945 19.2156 18.281 18.7916 17.9996 18.3436H22.2684L22.3247 18.2636L22.6462 17.7116L22.8874 17.2316L22.9276 17.1676L22.9678 17.0796H17.3082C17.1153 16.6636 16.9464 16.2396 16.8017 15.7996H23.4743L23.5306 15.6396L23.5788 15.4876L23.6994 15.0876L23.7315 14.9596C23.8223 14.6035 23.8947 14.243 23.9486 13.8796C23.7878 13.4796 23.7155 13.0476 23.7235 12.6156ZM5.08056 15.1516L5.83625 10.4796L4.16409 15.1516H3.27174L3.15919 10.5036L2.37135 15.1516H1.14939L2.17037 9.07159H4.05154L4.09978 12.8316L5.36998 9.07159H7.4039L6.39096 15.1516H5.08056ZM9.47801 15.1516L9.50213 14.6396C9.18056 15.0476 8.73037 15.2396 8.13547 15.2396C7.42801 15.2396 6.93762 14.6876 6.93762 13.8876C6.93762 12.6876 7.78174 11.9836 9.23684 11.9836C9.38154 11.9836 9.57448 11.9916 9.76743 12.0236C9.80762 11.8556 9.81566 11.7836 9.81566 11.7036C9.81566 11.3676 9.59056 11.2476 8.97958 11.2476C8.50527 11.2476 8.03899 11.3276 7.59684 11.4716L7.78174 10.3516C8.2855 10.1878 8.81142 10.1015 9.34135 10.0956C10.4668 10.0956 11.0617 10.5996 11.0617 11.5436C11.0617 11.7996 11.0215 12.1116 10.9572 12.5276C10.8447 13.2476 10.5955 14.7836 10.5633 15.1516H9.48605H9.47801ZM13.3047 12.2076C13.9639 12.5116 14.2292 12.9036 14.2292 13.5836C14.2292 14.7196 13.5941 15.2396 12.2194 15.2396C11.4155 15.2156 11.1502 15.1596 10.8527 15.0956L11.0296 13.9516C11.4476 14.0876 11.8174 14.1436 12.2033 14.1436C12.7259 14.1436 12.959 14.0076 12.959 13.7036C12.959 13.4716 12.8786 13.3996 12.348 13.1516C11.6566 12.8316 11.3512 12.3996 11.3512 11.7756C11.3512 10.8556 11.8496 10.0956 13.3127 10.0956C13.6102 10.0956 14.1247 10.1436 14.4623 10.1916L14.2774 11.3436C13.9659 11.2969 13.6518 11.2702 13.3368 11.2636C12.9188 11.2636 12.6937 11.4076 12.6937 11.6716C12.6937 11.9036 12.7661 11.9596 13.3127 12.2076H13.3047ZM16.7857 11.3916H16.1184C15.9657 12.3356 15.7486 13.5116 15.7486 13.6636C15.7486 13.9196 15.8853 14.0316 16.1988 14.0316C16.3435 14.0316 16.4641 14.0156 16.5525 13.9836L16.3757 15.0796C16.0139 15.1916 15.7325 15.2396 15.4351 15.2396C14.7678 15.2396 14.398 14.8556 14.398 14.1516C14.398 13.9356 14.5025 13.3516 14.5829 12.8316L15.1457 9.45559H16.448L16.2953 10.2076H16.9625L16.7857 11.3996V11.3916ZM19.2296 14.1196C19.6959 14.1196 20.1139 14.0236 20.5802 13.8076L20.3631 15.0396C19.921 15.1756 19.4868 15.2396 19.0286 15.2396C17.5815 15.2396 16.8178 14.4796 16.8178 13.0316C16.8178 11.3436 17.7825 10.0956 19.0929 10.0956C20.1621 10.0956 20.8455 10.7916 20.8455 11.8876C20.8455 12.2476 20.7972 12.6076 20.6847 13.1036H18.0961C18.0157 13.8236 18.4739 14.1196 19.2215 14.1196H19.2296Z"
                    fill="#E90119"
                  />
                </svg>
                <svg
                  className="mastercard-part part2"
                  width="41"
                  height="24"
                  viewBox="0 0 41 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    opacity="0.55"
                    d="M28.2247 1.02121e-05C26.4453 -0.00230514 24.6876 0.389122 23.079 1.14596C21.4703 1.90279 20.0508 3.0061 18.9233 4.37601H21.3512C21.6888 4.77601 21.9943 5.20001 22.2757 5.64801H17.9988C17.7496 6.05601 17.5165 6.48001 17.3075 6.92001H22.9671C23.16 7.32801 23.3288 7.75201 23.4816 8.19201H16.801C16.6563 8.60801 16.5437 9.02401 16.4473 9.45601H23.8273L23.9559 10.176C23.9881 10.4 24.0202 10.624 24.0363 10.848C24.5106 9.66401 25.4592 8.92801 26.6731 8.92801C27.2359 8.92801 27.9192 9.16801 28.1122 9.24001L27.8951 10.56C27.4288 10.32 27.0912 10.232 26.7214 10.232C25.7567 10.232 25.0653 11.168 25.0653 12.512C25.0653 13.432 25.5235 13.992 26.2873 13.992C26.6088 13.992 26.9626 13.896 27.3967 13.672L27.1635 15.064C26.6812 15.2 26.3757 15.248 26.0059 15.248C25.5621 15.2684 25.1234 15.1475 24.7534 14.903C24.3833 14.6584 24.1012 14.3029 23.9479 13.888C23.8433 14.552 23.6826 15.192 23.4816 15.808H16.801C16.9457 16.248 17.1145 16.672 17.3075 17.088H22.9671C22.7581 17.52 22.533 17.944 22.2757 18.352H18.0069C18.2802 18.8 18.5857 19.224 18.9233 19.632H21.3512C20.9805 20.0819 20.5775 20.5043 20.1453 20.896C21.5971 22.1994 23.3458 23.1316 25.2404 23.6123C27.1351 24.093 29.1188 24.1077 31.0205 23.6551C32.9221 23.2026 34.6845 22.2963 36.1557 21.0146C37.6268 19.7329 38.7624 18.1143 39.4645 16.2983C40.1667 14.4824 40.4142 12.5237 40.1858 10.5913C39.9574 8.65885 39.26 6.81077 38.1536 5.20648C37.0472 3.60219 35.5652 2.28989 33.8354 1.38283C32.1056 0.475759 30.18 0.00116899 28.2247 1.02121e-05ZM31.1671 15.152H30.0898L30.1139 14.64C29.7843 15.04 29.3422 15.24 28.7473 15.24C28.0237 15.24 27.5414 14.688 27.5414 13.888C27.5414 12.688 28.3935 11.984 29.8406 11.984C29.9853 11.984 30.1782 11.992 30.3712 12.016C30.4114 11.856 30.4275 11.784 30.4275 11.696C30.4275 11.376 30.1943 11.248 29.5833 11.248C29.1171 11.248 28.6508 11.328 28.2006 11.472L28.3855 10.352C28.8918 10.1874 29.4205 10.1011 29.9531 10.096C31.0786 10.096 31.6655 10.592 31.6655 11.544C31.6655 11.8 31.6253 12.112 31.561 12.528C31.4484 13.248 31.2073 14.784 31.1751 15.152H31.1671ZM32.9116 15.152H31.6092L31.6655 14.824C31.8906 13.288 32.18 11.736 32.3488 10.208H33.5547C33.5547 10.456 33.5065 10.704 33.4743 10.952C33.8763 10.368 34.1737 10.064 34.7204 10.176C34.4823 10.6276 34.3169 11.1135 34.23 11.616C33.4904 11.536 33.3779 12.128 32.9116 15.152ZM36.8508 15.152L36.9151 14.696C36.5533 15.072 36.1916 15.24 35.7092 15.24C34.7606 15.24 34.1335 14.424 34.1335 13.184C34.1335 11.544 35.1063 10.152 36.2559 10.152C36.7704 10.152 37.1482 10.36 37.51 10.824L37.7994 9.06401H39.0857L38.0969 15.152H36.8508Z"
                    fill="#F79F19"
                  />
                  <path
                    opacity="0.55"
                    d="M36.5043 11.376C35.9174 11.376 35.4914 12.064 35.4914 13.04C35.4914 13.68 35.7165 14.016 36.1586 14.016C36.7696 14.016 37.2037 13.328 37.2037 12.344C37.2037 11.72 36.9625 11.376 36.5043 11.376ZM28.8108 13.68C28.8108 13.992 28.9957 14.192 29.277 14.192C29.8076 14.192 30.1935 13.68 30.2176 12.952C30.1218 12.9376 30.0251 12.9296 29.9282 12.928C29.1806 12.928 28.8027 13.184 28.8027 13.68H28.8108Z"
                    fill="#B3761B"
                  />
                </svg>

                <svg
                  className="mastercard-part part3"
                  width="41"
                  height="24"
                  viewBox="0 0 41 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.0278 11.2236C18.6098 11.2236 18.3204 11.5436 18.1998 12.1036H19.6308C19.6388 11.9996 19.7674 11.2236 19.0278 11.2236ZM8.20703 13.6796C8.20703 13.9916 8.38389 14.1916 8.67331 14.1916C9.20389 14.1916 9.58978 13.6796 9.61389 12.9516C9.51541 12.9369 9.41603 12.9288 9.31644 12.9276C8.57684 12.9276 8.20703 13.1836 8.20703 13.6796Z"
                    fill="#E90119"
                  />
                </svg>
              </div>
            </div>
            {/* <img src="/img/eth.png" alt="IMG" className="ms-2 ms-md-3" /> */}
            <div className="eth-container">
              <svg
                className="eth-icon eth-icon--gray"
                viewBox="0 0 15 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_eth_gray"
                  mask-type="luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="15"
                  height="24"
                >
                  <path d="M0.0546875 0H14.4231V24H0.0546875V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_eth_gray)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.316498 10.752L7.29545 7.776L14.0612 10.832L7.28755 0L0.316498 10.752ZM0.340182 14.064L7.31123 18.152L14.4165 14.064L7.37439 24L0.340182 14.064Z"
                    fill="#646474"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.32575 9.23163L0.0625916 12.3356L7.32575 16.4236L14.3994 12.4236L7.32575 9.22363V9.23163Z"
                    fill="#646474"
                  />
                </g>
              </svg>

              <svg
                className="eth-icon eth-icon--color"
                viewBox="0 0 15 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask
                  id="mask0_eth_color"
                  mask-type="luminance"
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="15"
                  height="24"
                >
                  <path d="M0.0546875 0H14.4231V24H0.0546875V0Z" fill="white" />
                </mask>
                <g mask="url(#mask0_eth_color)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.316498 10.752L7.29545 7.776L14.0612 10.832L7.28755 0L0.316498 10.752ZM0.340182 14.064L7.31123 18.152L14.4165 14.064L7.37439 24L0.340182 14.064Z"
                    fill="#627EEA"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.32575 9.23163L0.0625916 12.3356L7.32575 16.4236L14.3994 12.4236L7.32575 9.22363V9.23163Z"
                    fill="#627EEA"
                  />
                </g>
              </svg>
            </div>
            {/* <img src="/img/bitcoin.png" alt="IMG" className="ms-2 ms-md-3" /> */}
            <div className="bitcoin-container">
              <svg
                className="bitcoin-icon bitcoin-icon--gray"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_217_1496)">
                  <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.6466 10.2768C17.4388 11.5402 16.7767 12.1577 15.882 12.3756C17.0725 13.042 17.6455 14.0534 17.0326 15.8276C16.2703 18.0528 14.564 18.2546 12.304 17.8236L11.7221 20.172L10.4089 19.8466L10.9908 17.4982C10.8422 17.4586 10.6925 17.4239 10.5428 17.3891C10.3364 17.3411 10.1232 17.2914 9.91224 17.2308L9.33037 19.5793L8.0196 19.2545L8.60143 16.906L5.99033 16.1948L6.63934 14.5343C6.63934 14.5343 7.62488 14.8054 7.6096 14.7883C7.97514 14.8772 8.15387 14.6219 8.22709 14.4431L9.15884 10.6782L9.837 8.00231C9.86628 7.71307 9.77568 7.33468 9.24156 7.19071C9.27792 7.16941 8.28008 6.95244 8.28008 6.95244L8.66892 5.37874L11.36 6.04567L11.9299 3.74531L13.2857 4.08131L12.7158 6.38167C13.0658 6.45781 13.4053 6.55034 13.755 6.63923L14.3249 4.33885L15.644 4.66577L15.0592 7.02644C16.723 7.63688 17.9214 8.54132 17.6466 10.2768ZM11.5274 10.7452C12.3158 10.982 14.6533 11.6845 15.0472 10.1204C15.4138 8.63363 13.3882 8.1794 12.4471 7.9684C12.3362 7.94351 12.2404 7.92202 12.1652 7.9026L11.4617 10.7254L11.5274 10.7452ZM10.31 15.3292L10.4243 15.363C11.3956 15.652 14.1516 16.4717 14.5254 14.9192C14.9105 13.4242 12.4328 12.8419 11.3236 12.5813C11.202 12.5527 11.0968 12.528 11.0137 12.5064L10.31 15.3292Z"
                    fill="#646474"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_217_1496">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg
                className="bitcoin-icon bitcoin-icon--color"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_217_1496)">
                  <path
                    d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.6466 10.2768C17.4388 11.5402 16.7767 12.1577 15.882 12.3756C17.0725 13.042 17.6455 14.0534 17.0326 15.8276C16.2703 18.0528 14.564 18.2546 12.304 17.8236L11.7221 20.172L10.4089 19.8466L10.9908 17.4982C10.8422 17.4586 10.6925 17.4239 10.5428 17.3891C10.3364 17.3411 10.1232 17.2914 9.91224 17.2308L9.33037 19.5793L8.0196 19.2545L8.60143 16.906L5.99033 16.1948L6.63934 14.5343C6.63934 14.5343 7.62488 14.8054 7.6096 14.7883C7.97514 14.8772 8.15387 14.6219 8.22709 14.4431L9.15884 10.6782L9.837 8.00231C9.86628 7.71307 9.77568 7.33468 9.24156 7.19071C9.27792 7.16941 8.28008 6.95244 8.28008 6.95244L8.66892 5.37874L11.36 6.04567L11.9299 3.74531L13.2857 4.08131L12.7158 6.38167C13.0658 6.45781 13.4053 6.55034 13.755 6.63923L14.3249 4.33885L15.644 4.66577L15.0592 7.02644C16.723 7.63688 17.9214 8.54132 17.6466 10.2768ZM11.5274 10.7452C12.3158 10.982 14.6533 11.6845 15.0472 10.1204C15.4138 8.63363 13.3882 8.1794 12.4471 7.9684C12.3362 7.94351 12.2404 7.92202 12.1652 7.9026L11.4617 10.7254L11.5274 10.7452ZM10.31 15.3292L10.4243 15.363C11.3956 15.652 14.1516 16.4717 14.5254 14.9192C14.9105 13.4242 12.4328 12.8419 11.3236 12.5813C11.202 12.5527 11.0968 12.528 11.0137 12.5064L10.31 15.3292Z"
                    fill="#F8931A"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_217_1496">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            {/* <img src="/img/zcash.png" alt="IMG" className="ms-2 ms-md-3" /> */}
            <div className="zcash-container">
              <svg
                className="zcash-icon zcash-icon--gray"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C18.616 1.93175e-07 24 5.384 24 12C24 18.616 18.616 24 12 24C5.376 24 0 18.616 0 12C0 5.384 5.376 0 12 0ZM10.9932 6.43164H7.70508V8.85645H12.7852L7.71387 15.7363V17.5762H10.9854V19.5762H12.9932V17.5762H16.2734V15.1436H11.1934L16.2734 8.26367L16.2812 8.25586V6.43164H13.001V4.41602H10.9932V6.43164Z"
                  fill="#646474"
                />
              </svg>

              <svg
                className="zcash-icon zcash-icon--color"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C18.616 1.93175e-07 24 5.384 24 12C24 18.616 18.616 24 12 24C5.376 24 0 18.616 0 12C0 5.384 5.376 0 12 0ZM10.9932 6.43164H7.70508V8.85645H12.7852L7.71387 15.7363V17.5762H10.9854V19.5762H12.9932V17.5762H16.2734V15.1436H11.1934L16.2734 8.26367L16.2812 8.25586V6.43164H13.001V4.41602H10.9932V6.43164Z"
                  fill="#23C1FF"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
